import { listen } from '@theme/shared-import-quicklink';

listen({
  // Same-origin only — never cross-origin on a storefront
  origins: [location.hostname],
  // Cap concurrent + total requests so you don't hammer Shopify's CDN/backend on collection/PLP pages with lots of links
  throttle: 3,
  limit: 30,
  // Give the browser more breathing room before kicking in
  timeout: 3000,
  // Skip cheap accidental prefetches from fast scrolling
  delay: 300,
  ignores: [
    /\/cart\/?/,
    /\/account\/?/,
    /\/search\/?/,
    /\/apps\/?/, 
    (uri) => uri.includes("#"),
    (uri) => uri.includes(".zip"),
    (uri, elem) => elem.hasAttribute("noprefetch"),
  ],
});